import api from '../api';

const SUBPAGE_LIST = api.events.subpagesGet.actionSuccess;

const defaultState = { list: [] };

export default (state = defaultState, action) => {
  switch (action.type) {
    case SUBPAGE_LIST:
      return { ...state, list: action.data };
    default:
      return state;
  }
};
